// extracted by mini-css-extract-plugin
module.exports = {"feature":"Feature-module--feature--oPxuY","icon":"Feature-module--icon--3XowK"};